import { fetchWithAuth } from './fetchWithAuth';

export const fetchAccountingList = async (acc_year) => {
  return fetchWithAuth(`/accounting?acc_year=${acc_year}`);
};

export const createAccounting = async (form) => {
  return fetchWithAuth(`/accounting`, { method: 'POST', body: JSON.stringify(form) });
};

export const updateAccounting = async (acc_year, seq_no, form) => {
  return fetchWithAuth(`/accounting/${acc_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

export const deleteAccounting = async (acc_year, seq_no) => {
  return fetchWithAuth(`/accounting/${acc_year}/${seq_no}`, { method: 'DELETE' });
};